<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const page = usePage();

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    brand: { type: Object, default: () => ({}) },
});

const brandLogoUrl = computed(() => props.brand?.logo || page.props.brand?.logo || '');

const alignClass = computed(() => {
    const align = props.row?.content?.logoAlign ?? 'center';
    if (align === 'center') return 'justify-center';
    if (align === 'right') return 'justify-end';
    return 'justify-start';
});

const logoSize = computed(() => props.row?.content?.logoSize ?? 80);
</script>

<template>
    <div v-if="brandLogoUrl" class="w-full p-fl-4">
        <div
            class="flex items-center w-full"
            :class="alignClass"
            :style="`height: ${logoSize}px;`"
        >
            <img
                :src="brandLogoUrl"
                alt="Brand logo"
                class="h-full max-w-full object-contain"
            >
        </div>
    </div>
</template>
